import { itwApi } from '@application/api/middlewares/api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
const initialState = {
    systemLocation: null,
    loading: false,
    error: null,
    assetId: '',
    projectId: '',
    systemId: null
};
export const fetchSystemLocations = createAsyncThunk('applicationGps/fetchGpsInfo', async (_, { rejectWithValue }) => {
    try {
        const response = await itwApi.get('System/active-system-location');
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error.response?.data?.message || 'Failed to fetch systems locations');
    }
});
export const gpsAndStreamsSlice = createSlice({
    name: 'applicationDashboard',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSystemLocations.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchSystemLocations.fulfilled, (state, action) => {
            state.loading = false;
            state.systemLocation = action.payload;
            state.error = null;
        })
            .addCase(fetchSystemLocations.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    }
});
export const {} = gpsAndStreamsSlice.actions;
export default gpsAndStreamsSlice.reducer;
